import { ArrowDownwardOutlined, RefreshOutlined } from '@material-ui/icons';
import InfoIcon from '@material-ui/icons/HelpOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import LockIcon from '@material-ui/icons/LockOpen';
import { BLUE, GREEN, ORANGE, PERMISSION_ENTITIES, PERMISSIONS, RED } from '../../_config/consts.js';
import { formatGatewayVersion, getHyperGateImage } from '../../_config/utils.js';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import DoorIconCustom from '../CustomIcons/DoorIconCustom.jsx';
import WarningOutlineIconCustom from '../CustomIcons/WarningOutlineIconCustom.jsx';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import AddLocksToGatewayForm from '../forms/GatewayForm/AddLocksToGatewayForm.jsx';
import LockDetailsRow from '../Locks/LockDetailsRow.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import { IconButton } from '@material-ui/core';
import * as UtilsActions from '../../redux/actions/utils.actions';
import InfoSection from '../InfoSection/InfoSection.jsx';
import WearableSettingsForm from '../forms/WearableForm/WearableSettingsForm.jsx';
import { submit } from 'redux-form';

@connect((state) => ({ gateways: state.gateways, userToken: state.user.token }))
class GatewayDetails extends React.Component {
  render() {
    const { dispatch, gateways: { selectedGateway: gateway }, onUpdateWearableSettingsForGateway, userToken, onForceSynchronization, onRestartGateway, onOpenLock, onAddLockToGateway, isAddingLockToGateway, onRemoveSmartLock, onRefreshGatewayData } = this.props;
    const canControlGateway = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.ALL], PERMISSION_ENTITIES.GATEWAY_NOTIFICATION);
    const isHyperGatePro = gateway && gateway.deviceOs === 'linux';
    const isGatewayOffline = gateway.lastConnectionDate ? moment(moment().valueOf()).diff(moment(gateway.lastConnectionDate), 'minutes') > 5 : false;
    const canAddLockToGateway = userToken && userToken.impersonateId;
    const isWearableAddonActive = dispatch(UtilsActions.isWearablesManagementActive());
    return (
      <div style={{ paddingTop: 0 }}>
        <FormFlatContainer headerStyle={{ marginBottom: 0 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>
            <div className="rounded-view" style={{ marginRight: 15 }}>
              <img className="lock-icon" style={{ marginTop: 0, width: '100%', height: '100%', borderRadius: '50%' }} src={getHyperGateImage(gateway.deviceType)} />
            </div>
            {/* <GatewayNameInlineForm
              onValidateForm={() => dispatch(submit('GatewayNameInlineForm'))}
              onSubmit={values => onModifyGatewayName(values)}
              disabled={!canControlGateway}
              hideEditIcon={false}
            /> */}
            {gateway.highFlex ? (
              <div style={{ position: 'absolute', top: 15, right: 15, backgroundColor: BLUE, padding: 10, width: 'fit-content', borderRadius: 5, display: 'flex', alignItems: 'center', height: 30 }}>
                <h5 style={{ color: 'white', margin: 0}}>{'High flex'}</h5>
              </div>
              ): null}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4 style={{ fontSize: 30, margin: 0, marginLeft: 10, color: '#3f3f3f', fontWeight: 'bold' }}>
                  {gateway.name}
                </h4>
                <IconButton
                  onClick={() => onRefreshGatewayData(gateway.id)}
                  style={{ marginLeft: 10 }}
                >
                  <RefreshOutlined style={{ fontSize: 30, color: '#3f3f3f' }} />
                </IconButton>
              </div>
          </div>
          <div>
            <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
              {'ID'}
            </h5>
            <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
              {gateway.id}
            </h4>
          </div>
          {gateway.deviceType ? (
            <div>
            <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
              <Entity entity="gatewayDeviceType" />
            </h5>
            <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
              <Entity entity="gatewayDeviceTypes" data={{ type: gateway.deviceType }} />
            </h4>
          </div>
          ): null}
          {gateway.deviceId && isHyperGatePro ? (
            <div>
              <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
                <Entity entity="serialNumber" />
              </h5>
              <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
                {gateway.deviceId}
              </h4>
            </div>
          ) : null}
          {gateway.lastConnectionDate && (
            <div>
              <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
                <Entity entity="lastConnectionDate" />
              </h5>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
                  {moment(gateway.lastConnectionDate).format('LLL')}
                </h4>
                {isGatewayOffline && 
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <WarningOutlineIconCustom style={{ marginLeft: 10, width: 20, color: 'red' }} />
                    <IconButton
                      onClick={() => onRefreshGatewayData(gateway.id)}
                      style={{ marginLeft: 0 }}
                    >
                      <RefreshOutlined style={{ fontSize: 20, color: '#3f3f3f' }} />
                    </IconButton>
                  </div>
                }
              </div>
            </div>
          )}
          {gateway.deviceVersion ? (
            <div>
              <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
                <Entity entity="firmwareVersion" />
              </h5>
              <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
                {formatGatewayVersion(gateway.deviceVersion) || ''}
              </h4>
            </div>
          ): null}
          {gateway.iseoSdkVersion && gateway.iseoSdkVersion.length > 0 ? (
            <div>
            <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
              <Entity entity="hyperGateIseoSdkVersion" />
            </h5>
            <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
              {gateway.iseoSdkVersion || '---'}
            </h4>
          </div>
          ) : null}
          {gateway.kernelVersion ? (
            <div>
            <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
              <Entity entity="kernelVersion" />
            </h5>
            <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
              {gateway.kernelVersion || '---'}
            </h4>
          </div>
          ) : null}
          
          {gateway.minFeatureLevel && gateway.maxFeatureLevel ? (
            <div>
              <h5 style={{ fontSize: 18, margin: 0, marginBottom: 10, marginTop: 20, color: '#3f3f3f', fontWeight: 'bold' }}>
                <Entity entity="hyperGateFeatureLevelSupported" />
              </h5>
              <h4 style={{ fontSize: 18, margin: 0, color: '#3f3f3f' }}>
                {`${gateway.minFeatureLevel} - ${gateway.maxFeatureLevel}`}
              </h4>
            </div>
          ): null}
        </FormFlatContainer>
        {canControlGateway &&
          <FormFlatContainer containerStyle={{ marginTop: 20 }} title="restartGatewayTitle" subtitle="restartGatewayDescription" icon={<RefreshOutlined style={{ fontSize: 20 }} />}>
            <MDButton
              title={<Entity entity="restart" />}
              backgroundColor={ORANGE}
              disabled={isGatewayOffline}
              containerStyle={{ opacity: isGatewayOffline ? 0.5 : 1, marginBottom: 20 }}
              onClick={() => onRestartGateway()}
            />
            {isGatewayOffline ? (
              <InfoSection
                title="gatewayIsOffline"
                gravity="error"
                titleStyle={{ fontWeight: 'normal' }}
              />
            ): null}
            <InfoSection
              title="restartGatewayDescriptionWarning"
              gravity="info"
              titleStyle={{ fontWeight: 'normal' }}
            />
          </FormFlatContainer>
        }
        {canControlGateway &&
          <FormFlatContainer containerStyle={{ marginTop: 20 }} title="forceSyncronization" subtitle="forceSyncronizationDescription" icon={<ArrowDownwardOutlined style={{ fontSize: 20 }} />}>
            <MDButton
              title={<Entity entity="forceSyncronization" />}
              backgroundColor={BLUE}
              disabled={isGatewayOffline}
              containerStyle={{ opacity: isGatewayOffline ? 0.5 : 1, marginBottom: 10 }}
              onClick={() => onForceSynchronization()}
            />
            {isGatewayOffline ? (
              <InfoSection
                title="gatewayIsOffline"
                gravity="error"
                titleStyle={{ fontWeight: 'normal' }}
              />
            ): null}
          </FormFlatContainer>
        }
        <FormFlatContainer containerStyle={{ marginTop: 20 }} title="gatewayLocks" subtitle="gatewayLocksDescription" icon={<DoorIconCustom style={{ width: 20 }} />}>
          {canAddLockToGateway ? (
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 40, marginTop: 20 }}>
              <AddLocksToGatewayForm
                locksToExclude={gateway.smartLocks}
                isListLoading={isAddingLockToGateway}
                isGatewayOffline={isGatewayOffline}
                onAddLockToGateway={(lock) => onAddLockToGateway(lock)}
              />
            </div>
            ) : null}
            {!_.isEmpty(gateway.smartLocks) ?
              <>
                {_.map(gateway.smartLocks, smartLock => (
                  <LockDetailsRow
                    key={smartLock.id}
                    lock={smartLock}
                    onOpenLock={() => onOpenLock(smartLock)}
                    onRemoveSmartLock={canAddLockToGateway ? () => onRemoveSmartLock(smartLock) : null}
                    onRemoveSmartLockButtonDisabled={isGatewayOffline}
                  />
                ),
              )}
            </>
          : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, justifyContent: 'center', marginBottom: 30 }}>
              <LockIcon style={{ fontSize: 25, color: 'gray' }} />
              <h4 style={{ fontSize: 18, margin: 0, marginTop: 10, color: 'gray' }}>
                <Entity entity="noGatewayLocksFound" />
              </h4>
            </div>
          )}
        </FormFlatContainer>
        {isWearableAddonActive ? (
          <FormFlatContainer containerStyle={{ marginTop: 20 }} title="wearableSettings" subtitle="wearableSettingsDescription" icon={<InfoIcon style={{ fontSize: 20 }} />}>
            <WearableSettingsForm onSubmit={(wearableSettings) => onUpdateWearableSettingsForGateway(gateway.id, wearableSettings)} />
            <MDButton
              title={<Entity entity="save" />}
              backgroundColor={GREEN}
              disabled={isGatewayOffline}
              containerStyle={{ opacity: isGatewayOffline ? 0.5 : 1, marginBottom: 20 }}
              onClick={() => dispatch(submit('WearableSettingsForm'))}
            />
          </FormFlatContainer>
        ) : null}
      </div>
    );
  }
} 

export default GatewayDetails;
